import { z } from 'zod';

/** BR-03: min. 8 znaków, co najmniej jedna cyfra i jedna wielka litera. */
export const PASSWORD_MIN_LENGTH = 8;

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, { message: `Hasło musi mieć co najmniej ${PASSWORD_MIN_LENGTH} znaków.` })
  .regex(/\d/, { message: 'Hasło musi zawierać co najmniej jedną cyfrę.' })
  .regex(/\p{Lu}/u, { message: 'Hasło musi zawierać co najmniej jedną wielką literę.' });

/** BR-01: e‑mail bez spacji na brzegach; porównania bez rozróżniania wielkości liter. */
export const emailSchema = z
  .string()
  .trim()
  .email({ message: 'Podaj poprawny adres e‑mail.' })
  .max(254);

/** Klucz do porównań adresów (BR-01). */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export const personNameSchema = z
  .string()
  .trim()
  .min(1, { message: 'To pole jest wymagane.' })
  .max(100, { message: 'Maksymalnie 100 znaków.' });
